import { useOutletContext } from "react-router-dom"
import {
  getGuardianEmail,
  getGuardianFirstName,
  getGuardianLastName,
  getPlanStudentEmail,
  getPlanStudentFirstName,
  getPlanStudentLastName,
} from "../lib/plan"
import { useMemo } from "react"
import { PLAN_STATUS } from "../constants/planStatus"
import { INVITE_STATUS } from "../constants/inviteStatus"

export const useOutletContextPlan = () => {
  const { plan, getPlan, refreshPlans } = useOutletContext()
  const student = useMemo(
    () =>
      plan && plan.youth && plan.youth[0]
        ? plan.youth[0]
        : {
            first_name: getPlanStudentFirstName(plan),
            last_name: getPlanStudentLastName(plan),
            email: getPlanStudentEmail(plan),
          },
    [plan],
  )

  const guide = useMemo(() => (plan && plan.guide && plan.guide[0] ? plan.guide[0] : null), [plan])

  const pendingGuide = useMemo(
    () => (plan && plan.pending_guide && plan.pending_guide[0] ? plan.pending_guide[0] : null),
    [plan],
  )

  const initiator = useMemo(
    () => (plan && plan.initiator && plan.initiator[0] ? plan.initiator[0] : null),
    [plan],
  )

  const guardians = useMemo(
    () => {
      if (plan && plan.guardians?.length > 0) return plan.guardians
      if (getGuardianFirstName(plan) === "") return []
      return [
        {
          first_name: getGuardianFirstName(plan),
          last_name: getGuardianLastName(plan),
          email: getGuardianEmail(plan),
        }
      ]
    },
    [plan],
  )

  const studentFirstName = useMemo(
    () => (student ? student.first_name : getPlanStudentFirstName(plan)),
    [student, plan],
  )

  const studentEmail = useMemo(
    () => (student ? student.email : getPlanStudentEmail(plan)),
    [student],
  )

  const guardianEmails = useMemo(
    () => (guardians ? guardians.map(g => g.email) : [getGuardianEmail(plan)]),
    [guardians],
  )

  const mentors = useMemo(() => (plan && plan.mentors ? plan.mentors : []), [plan])

  const currentStep = useMemo(() => plan?.status || "checklist-complete", [plan])

  const canInviteMentors = useMemo(
    () =>
      plan?.status !== PLAN_STATUS.CHOOSE_GUIDE &&
      plan?.status !== PLAN_STATUS.INVITE_STUDENT &&
      (plan?.mentors || []).some(m => m.invitation_status === INVITE_STATUS.NOT_INVITED),
    [plan],
  )

  const hasMentorContent = useMemo(
    () =>
      plan?.content?.some(c =>
        ["encouragements", "commitments", "audio_blessings", "text_blessings"].includes(c.key),
      ),
    [plan],
  )

  return {
    plan,
    getPlan,
    refreshPlans,

    currentStep,
    canInviteMentors,

    student,
    studentFirstName,
    studentEmail,

    guide,
    pendingGuide,
    initiator,

    guardians,
    guardianEmails,

    mentors,
    hasMentorContent,
  }
}
